import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import App from './app';
import { CONFIG } from './config-global';
import reportWebVitals from './reportWebVitals';
import {SplashScreen} from "./components/loading-screen";
import { installAuthInterceptor } from './pages/admin/providers/authInterceptor';

// XBIT-4826: the refresh-and-retry for every screen that calls the default axios instance.
installAuthInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={CONFIG.site.basePath}>
        <Suspense fallback={<SplashScreen />}>
          <App />
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
